import * as React from 'react';
import { CRBTUICSSStyle } from './crbtuicss';
import { UIDataModel, UIComponentState } from '../../../toolkit/uicomponent';
import { UIComponentViewImpl } from '../../../toolkit/uicomponentview';
import { CRBTUIComponentProps } from './crbtuicomponent';
import { ImageLoaderComponent } from '../../../toolkit/imageloader/imageloadercomponent';
import { BannerImageLoaderCSSStyleImpl } from '../banner/bannerimageloadercss';
import { NavigationPathComponent } from '../../navigation/navigationpathcomponent/navigationpathcomponent';
import './crbt-style.css';
import { LanguageConst } from 'src/com/sixdee/crbtportal/utils/resources/languageconst';

export class CRBTUIViewImpl extends UIComponentViewImpl<UIDataModel> {
    draw(props: CRBTUIComponentProps, state: UIComponentState, cssStyle: CRBTUICSSStyle): JSX.Element | boolean {
        super.draw(props, state, cssStyle);

        return (
            <>
                {
                    this.crbtWebWrapper(props, state, cssStyle)
                }

            </>);
    }

    crbtWebWrapper(props: CRBTUIComponentProps, state: UIComponentState, cssStyle: CRBTUICSSStyle) {
        return (
            <>
                <div style={{ width: "100%", height: "100%" }}>
                    {
                        props.isBannerRequired && <ImageLoaderComponent defaultImageName={"default_image.jpg"} imagePath={props.context.getResources().getImage(this.getBannerImg())} imageLoaderCSSStyle={new BannerImageLoaderCSSStyleImpl(props.context)} context={props.context} />}
                    {
                        props.isNavigationPathRequired && <NavigationPathComponent listOfPaths={this.getNavigationPath()} context={props.context} />}
                    <div id="crbt-inner-wrapper" style={cssStyle.getInnerCSSStyle()}>
                        {
                            this.getChildComponent(props, state, cssStyle)
                        }
                    </div>
                </div>
                {props.isFlashMessageRequired && <>
                    {<div id="flash-message-set-now-web-div">
                        {this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ?
                            <img style={{ height: "auto", cursor: "pointer", width: "100%", display: "flex", flexFlow: "row wrap" }} src={this.getUIProps().context.getResources().getImage("setnow_banner_web.svg")} />
                            : <img style={{ height: "auto", cursor: "pointer", width: "100%", display: "flex", flexFlow: "row wrap" }} src={this.getUIProps().context.getResources().getImage("setnow_banner_web_burmese.svg")} />
                        }
                    </div>}

                    {<div id="flash-message-set-now-mobile-div">
                        {this.getContext().getUserContext().getLanguage() === LanguageConst.ENGLISH ?
                            <img style={{ height: "auto", cursor: "pointer", width: "100%", display: "flex", flexFlow: "row wrap" }} src={this.getUIProps().context.getResources().getImage("setnow_banner_mobile.svg")} />
                            : <img style={{ height: "auto", cursor: "pointer", width: "100%", display: "flex", flexFlow: "row wrap" }} src={this.getUIProps().context.getResources().getImage("setnow_banner_mobile_burmese.svg")} />
                        }
                    </div>}
                </>}
            </>
        );
    }

    protected getNavigationPath(): string[] {
        return [];
    }

    protected getBannerImg(): string {
        return "";
    }

    protected getChildComponent(props: CRBTUIComponentProps, state: UIComponentState, cssStyle: CRBTUICSSStyle): JSX.Element {
        return <></>;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/crbt/crbtuiview.tsx